import { ensurePhonesArray } from '@@viewHelpers/ensurePhonesArray';
import { modifyPath } from 'ramda';

export const extraFormatProject = modifyPath(
  ['customer'],
  ensurePhonesArray
);
